export default "__VITE_ASSET__eCGj18D___"